import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import { Link } from "react-router-dom";

class Sidebar extends Component {

    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };

    render() {
        //const { user } = this.props.auth;
        return (
            <div className="border-right h-100" id="sidebar-wrapper">
                <div className="list-group list-group-flush">
                    <Link to="/commisions" className="list-group-item list-group-item-action">Commission</Link>
                    {/* <Link to="/settings" className="list-group-item list-group-item-action">Settings</Link> */}
                    <Link to="/liqutity" className="list-group-item list-group-item-action">Liquidity</Link>
                    <Link to="/swapping" className="list-group-item list-group-item-action">Swapping</Link>
                    <Link to="/farms" className="list-group-item list-group-item-action">Farms</Link>
                    <Link to="/pools" className="list-group-item list-group-item-action">Pools</Link>
                    <Link to="/setting" className="list-group-item list-group-item-action">IFO Settings</Link>
                    <button className="list-group-item list-group-item-action" onClick={this.onLogoutClick}>Logout <FontAwesomeIcon icon={faSignOutAlt} /></button>
                </div>
            </div>
        );
    }
}

Sidebar.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(Sidebar);
